import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import HeaderNav from './components/layout/HeaderNav';
import Footer from './components/layout/Footer';
import LandingPage from './pages/LandingPage';
import GmpPage from './pages/GmpPage';
import GmpCompanyPage from './pages/GmpCompanyPage';
import IpoDashboardPage from './pages/IpoDashboardPage';
import IpoCalendarPage from './pages/IpoCalendarPage';
import UpcomingIposPage from './pages/UpcomingIposPage';
import IpoSubscriptionPage from './pages/IpoSubscriptionPage';
import IpoPerformancePage from './pages/IpoPerformancePage';
import IpoReviewsPage from './pages/IpoReviewsPage';
import SmeIposPage from './pages/SmeIposPage';
import SmeReviewsPage from './pages/SmeReviewsPage';
import SmeSubscriptionPage from './pages/SmeSubscriptionPage';
import SmeUpcomingIposPage from './pages/SmeUpcomingIposPage';
import SmeGmpPage from './pages/SmeGmpPage';
import IpoNewsPage from './pages/IpoNewsPage';
import DrhpTrackerPage from './pages/DrhpTrackerPage';
import DrhpFilingPage from './pages/DrhpFilingPage';
import SebiFilingsPage from './pages/SebiFilingsPage';
import IssueSubscriptionPage from './pages/IssueSubscriptionPage';
import TopSubscribedPage from './pages/TopSubscribedPage';
import IpoDetailsPage from './components/detail/IpoDetailsPage';
import ScrollToTop from './components/common/ScrollToTop';
import ContactModal from './components/contact/ContactModal';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-white text-slate-900 flex flex-col font-sans selection:bg-[#008080] selection:text-white">
          {/* Persistent Header Navigation with Logo on Left & Menus in Center */}
          <HeaderNav />

          {/* Page Routing */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/ipo-dashboard" element={<IpoDashboardPage />} />
            <Route path="/ipo-calendar" element={<IpoCalendarPage />} />
            <Route path="/upcoming-ipos" element={<UpcomingIposPage />} />
            <Route path="/ipo-subscription" element={<IpoSubscriptionPage />} />
            <Route path="/ipo-subscription/:symbol" element={<IssueSubscriptionPage />} />
            <Route path="/top-subscribed-ipos" element={<TopSubscribedPage />} />
            <Route path="/ipo-performance" element={<IpoPerformancePage />} />
            <Route path="/ipo-reviews" element={<IpoReviewsPage />} />
            <Route path="/sme-ipos" element={<SmeIposPage />} />
            <Route path="/sme-ipo-reviews" element={<SmeReviewsPage />} />
            <Route path="/sme-ipo-subscription" element={<SmeSubscriptionPage />} />
            <Route path="/sme-upcoming-ipos" element={<SmeUpcomingIposPage />} />
            <Route path="/sme-ipo-gmp" element={<SmeGmpPage />} />
            <Route path="/ipo-news" element={<IpoNewsPage />} />
            <Route path="/drhp-filings" element={<DrhpTrackerPage />} />
            <Route path="/drhp-filings/:id" element={<DrhpFilingPage />} />
            <Route path="/sebi-filings-approvals" element={<SebiFilingsPage />} />
            <Route path="/ipo-gmp" element={<GmpPage />} />
            <Route path="/ipo-gmp/:companySlug" element={<GmpCompanyPage />} />
            <Route path="/mainboardipo/:id" element={<IpoDetailsPage isSme={false} />} />
            <Route path="/smeipo/:id" element={<IpoDetailsPage isSme={true} />} />
            <Route path="/ipo/:id" element={<IpoDetailsPage />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>

          {/* Complete Footer */}
          <Footer />

          {/* Contact Us form, opened from the header and footer on any page */}
          <ContactModal />
        </div>
      </Router>
    </Provider>
  );
}

export default App;
